import { useState, JSX, ReactElement, SyntheticEvent } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    ExportButton,
    Datagrid,
    EditButton,
    SelectField,
} from 'react-admin';
import { nokStatuses, nokTypes } from "../../defaults/defaults";
import {
    Box,
    Tabs,
    Tab
} from '@mui/material';
import { NokTestingContainer } from './components/nok-list/NokTestingContainer';

const ListActions: () => ReactElement = (): ReactElement => {
    return(
        <TopToolbar>
            {/* Was isAdmin, which showed this button to ROLE_ADMIN while HQ-API held the write to
                super admin and above, so an admin got a create form the POST then refused.
                HQ_Nok::noks is the API's own tier, which closes the gap. */}
                <CreateButton />
            <ExportButton />
        </TopToolbar>
    );
}


export const NokList: () => JSX.Element = (): JSX.Element => {
    const [tab, setTab] = useState<number>(0);
    const [disableButtons, setDisableButtons] = useState<boolean>(false);

    function handleTabChange(event: SyntheticEvent, num: number): void {
        setTab(num);
    }

    function handleButtonDisable(value: boolean): void {
        setDisableButtons(value);
    }

    return (
        <Box sx={ {
            display: 'flex',
            flexDirection: 'column',
            padding: '20px 0 0 0'
        } }>
            { /* Real tabs rather than two Buttons where the active one is disabled: a disabled
                 control leaves the tab order entirely and is announced as unavailable rather
                 than selected. Tabs also brings arrow-key navigation and a focus ring. */ }
            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs value={ tab } onChange={ handleTabChange } aria-label="Nok views">
                    <Tab label="View Noks"
                         id="nok-tab-0"
                         aria-controls="nok-tabpanel-0"
                         disabled={ disableButtons }
                    />
                    <Tab label="Test Noks"
                         id="nok-tab-1"
                         aria-controls="nok-tabpanel-1"
                         disabled={ disableButtons }
                    />
                </Tabs>
            </Box>
            <Box>
                { (tab === 0) &&
                    <Box role="tabpanel" id="nok-tabpanel-0" aria-labelledby="nok-tab-0">
                        <List
                            actions={<ListActions/>}
                        >
                            <Datagrid bulkActionButtons={false} >
                                <TextField source="id" />
                                <TextField source="name"  />
                                <SelectField source="type" choices={ nokTypes } />
                                <SelectField source="status" choices={ nokStatuses } />
                                <EditButton />
                            </Datagrid>
                        </List>
                    </Box>
                }
                { (tab === 1) &&
                    <Box role="tabpanel" id="nok-tabpanel-1" aria-labelledby="nok-tab-1">
                        <NokTestingContainer handleButtonDisable={ handleButtonDisable } />
                    </Box>
                }
            </Box>
        </Box>
    );
}
